<template>
    <div v-if="!loading && loaded" class="grade_item-container">
        <h2 class="grade_item-name">Аналитика прохождения заданий</h2>
        <div class="chart">
            <apexchart type="bar" height="460" :options="options" :series="series"></apexchart>
        </div>
    </div>
</template>

<script>
import apexchart from 'vue-apexcharts';

export default {
    name: 'ResultsByMonth',
    components: { apexchart },
    props: {
        loading: Boolean
    },
    data: () => ({
        options: {
            legend: {
                showForSingleSeries: true,
                markers: {
                    radius: 12
                }
            }, 
            chart: {
                toolbar: {
                    show :false
                },
                width: '100%'
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: []
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return  val;
                    }
                },
            }
        },
        series: [{
            name: 'Количество прохождений',
            data: []
        }],
        loaded: false
    }),
    methods: {
        update(data) {
            this.options.xaxis.categories = [];
            this.series[0].data = [];

            data.forEach(x => {
                this.options.xaxis.categories.push(x.name);
                this.series[0].data.push(x.count);
            });

            this.loaded = true;
        }
    }
}
</script>
